export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#C9CBD4\" d=\"M8 0a8 8 0 100 16A8 8 0 008 0m3.707 10.293a1 1 0 11-1.414 1.414L8 9.414l-2.293 2.293a1 1 0 01-1.414-1.414L6.586 8 4.293 5.707a1 1 0 011.414-1.414L8 6.586l2.293-2.293a1 1 0 111.414 1.414L9.414 8z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};